import { cx } from '@linaria/core';
import { TransitionGroup } from 'react-transition-group';
import { speechButtonSelectors } from '@ui/kit/selectors';
import { CSSRefTransition } from '@utils/react';
import { playerTransitionDurationMs, playerContainerCls, playerCls } from './_sticky-audio-player.style.js';
import { AudioPlayer } from './molecule.audio-player.js';
import { jsx } from 'react/jsx-runtime';

function StickyAudioPlayer(props) {
  return /*#__PURE__*/jsx(TransitionGroup, {
    component: null,
    children: props.toggled && props.audioSrc && /*#__PURE__*/jsx(CSSRefTransition, {
      classNames: playerContainerCls,
      timeout: playerTransitionDurationMs,
      children: ref => /*#__PURE__*/jsx("div", {
        ref: ref,
        className: playerContainerCls,
        "data-disable-polly": true,
        children: /*#__PURE__*/jsx("div", {
          className: cx(playerCls, speechButtonSelectors.attachedAudioPlayer.className),
          children: /*#__PURE__*/jsx(AudioPlayer, {
            src: props.audioSrc,
            onEnd: props.onDeactivate
          })
        })
      })
    })
  });
}

export { StickyAudioPlayer };
//# sourceMappingURL=_sticky-audio-player.js.map
